import { CalendarMonth } from "@mui/icons-material";
import { Box, Dialog, Stack, useTheme } from "@mui/material";
import Calendar from "../displays/reservations/Calendar";
import { useState } from "react";

export default function CalendarPopup() {
  const [ open, setOpen ] = useState(false);

  const theme = useTheme();

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <>
    <Box
      display={{ xs: 'none', sm: 'block', md: 'block', lg: 'block', xl: 'block' }}
      position="fixed"
      right="15px"
      bottom="15px"
      borderRadius={250}
      onClick={handleClick}
      px={2}
      py={2.5}
      zIndex={9998}
      sx={{
        background: theme.palette.primary.main,
        cursor: 'pointer',
        '&:hover': {
          boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.25)',
          transition: 'box-shadow .3s'
        }
      }}
    >
      <CalendarMonth sx={{ width: '30px' }} />
    </Box>
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      PaperProps={{
        sx: {
          maxWidth: '80%',
          height: '80vh',
        }
      }}
    >
      <Stack p={2}>
        <Calendar height="75vh" />
      </Stack>
    </Dialog>
    </>
  );
}